import AlertComponent from "./AlertComponent";
import { SnackbarProvider } from "notistack";

const AlertProvider = ({ children }) => {
  return (
    <SnackbarProvider
      Components={{
        error: AlertComponent,
        warning: AlertComponent,
        info: AlertComponent,
        success: AlertComponent,
      }}
      variant="info"
      autoHideDuration={1500}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default AlertProvider;
